module.exports = __webpack_public_path__ + "static/media/User_Cat.010acde2.svg";